/**
 * Specifies the tolerance value type.
 * tag: 41046
 * @readonly
 * @enum {number} (int)
 */
export enum DeliveryScheduleToleranceType {
  /** Absolute */
  Absolute = 0,
  /** Percentage */
  Percentage = 1,
}
